import React from 'react';
import Nav2 from '../Nav2/Nav2';
import './detaildonasiurgent.css'
import Carousel from 'react-elastic-carousel';
import Image from './Rectangle 20.png'
import Uang from '../Cards/CardsImages/uang.png'
import { Link } from 'react-router-dom';
import ProgressDonasiUrgent from './Progress Bar/progressbar'
import Photouser from './photo user.png';
import VerifyIcon from './icon verify.png';



const data = [
    {
        id: 1,
        image: "",
        title: "Sofia butuh dana untuk operasi tumor kaki",
        icon: "",
        namaicon: "Dana",
        namakategori: "",
        jumlahdonasiterkumpul: 'Rp.5.000.332',
        jumlahsemuadonasi: "10.000.000",
        jumlahdonatur: "45",
        sisahari: '23 hari',
        namapenggalangdana: "Adam Malik",
        cerita: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In lectus amet arcu arcu. Quisque porta purus in aliquet etiam facilisis adipiscing semper. Justo, nunc diam nunc molestie erat sit faucibus vel consequat. Nunc sollicitudin id non auctor eleifend diam non laoreet pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In lectus amet arcu arcu. Quisque porta purus in aliquet etiam facilisis adipiscing semper. Justo, nunc diam nunc molestie erat sit faucibus vel consequat. Nunc sollicitudin id non auctor eleifend diam non laoreet pellentesque.",
        dana: "Rp. 2.340.231",
        tujuandonasi: "Untuk Operasi kecil pada kaki di RS Medika Pratama",
        namadonatur1: "Michael",
        namadonatur2: "Orang Baik",
        tanggaldonasi: "25 May 2021",
        jumlahdonasidonatur: "Rp.100.000"
    }
]

function DetailDonasiUrgent() {
    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 500, itemsToShow: 1 },
        { width: 768, itemsToShow: 2 },
        { width: 1200, itemsToShow: 2 },
    ];
    return (
        <>
            <Nav2 />
            {data.map(urgentdetail => (
                <div>
                    <Carousel breakPoints={breakPoints}>
                        <div className="card-urgentdetail">
                            <img src={Image} alt="" width="500" height="350" />
                        </div>
                        <div className="card-urgentdetail">
                            <img src={Image} alt="" width="500" height="350" />
                        </div>
                        <div className="card-urgentdetail">
                            <img src={Image} alt="" width="500" height="350" />
                        </div>
                    </Carousel>
                    <div className="style-margin">
                        <h5 className="card-title-detail">{urgentdetail.title}</h5>
                        <div className="card-icon-urgent-row">
                            <div className="icon-border-row">
                                <img src={Uang} alt="" width="60" height="" />
                                <h6 className="icon-txt-detail">{urgentdetail.namaicon}</h6>
                            </div>
                            <div>
                                <button className="kategori-btn-detail"><Link to="/kategori-kemanusiaan">Kemanusiaan</Link></button>
                            </div>
                        </div>
                        <p className="p-terkumpul">Terkumpul <span className="color-green">{urgentdetail.jumlahdonasiterkumpul}</span> dari {urgentdetail.jumlahsemuadonasi} </p>
                        <ProgressDonasiUrgent done="60" />
                        <div className="row-2">
                            <p className="jumlah-donatur-p">{urgentdetail.jumlahdonatur} Donatur</p>
                            <p className="sisa-hari-p">Sisa {urgentdetail.sisahari}</p>
                        </div>
                        <div className="card-tentang-donasi">
                            <h6 className="tentang-donasi-txt">Tentang Donasi</h6>
                            <hr border="solid 4" />
                            <p className="tentang-donasi-txt-2">Penggalang Dana</p>
                            <div className="card-user-identity">
                                <img src={Photouser} alt="" width="70" />
                                <div className="user-column">
                                    <div className="user-row">
                                        <h6 className="urgent-username">{urgentdetail.namapenggalangdana}</h6>
                                        <img src={VerifyIcon} alt="" width="50" />
                                    </div>
                                    <p className="ver-id">Identitas terverifikasi</p>
                                </div>
                            </div>
                            <p className="tentang-donasi-txt-2">Cerita</p>
                            <div className="cerita">
                                <div className="card-cerita">
                                    <p className="cerita-lorem">
                                        {urgentdetail.cerita}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card-berita-terbaru">
                            <p className="tentang-donasi-txt">Berita Terbaru</p>
                            <hr border="solid 4" />
                            <div className="card-dana">
                                <h6 className="dana-txt">Penarikan dana sebesar <span className="color-green">{urgentdetail.dana}</span></h6>
                                <p className="dana-txt-p">{urgentdetail.tujuandonasi}</p>
                            </div>
                            <div className="card-dana">
                                <h6 className="dana-txt">Penarikan dana sebesar <span className="color-green">{urgentdetail.dana}</span></h6>
                                <p className="dana-txt-p">{urgentdetail.tujuandonasi}</p>
                            </div>
                            <p className="card-dana-lihat">Lihat Selengkapnya</p>
                        </div>
                        <div className="card-donatur">
                            <p className="tentang-donasi-txt">Donatur</p>
                            <hr border="solid 4" />
                            <div className="card-donatur-1">
                                <div class="donatur-row">
                                    <h6 className="dana-txt">{urgentdetail.namadonatur1}</h6>
                                    <p className="dana-txt-row">{urgentdetail.tanggaldonasi}</p>
                                </div>
                                <p className="dana-txt-p">Berdonasi sebesar <span className="color-green">{urgentdetail.jumlahdonasidonatur}</span></p>
                            </div>
                            <div className="card-donatur-1">
                                <div class="donatur-row">
                                    <h6 className="dana-txt">{urgentdetail.namadonatur1}</h6>
                                    <p className="dana-txt-row">{urgentdetail.tanggaldonasi}</p>
                                </div>
                                <p className="dana-txt-p">Berdonasi sebesar <span className="color-green">{urgentdetail.jumlahdonasidonatur}</span></p>
                            </div>
                            <div className="card-donatur-1">
                                <div class="donatur-row">
                                    <h6 className="dana-txt">{urgentdetail.namadonatur1}</h6>
                                    <p className="dana-txt-row">{urgentdetail.tanggaldonasi}</p>
                                </div>
                                <p className="dana-txt-p">Berdonasi sebesar <span className="color-green">{urgentdetail.jumlahdonasidonatur}</span></p>
                            </div>
                            <p className="card-dana-lihat">Lihat Selengkapnya</p>
                        </div>
                        <div>
                            <button className="urgent-detail-btn">
                                <Link to="donasi-sekarang">
                                    Donasi Sekarang</Link>
                            </button>
                        </div>
                    </div>

                </div>
            ))}

        </>
    );
};


export default DetailDonasiUrgent;